// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-pages-components-pageContentWrapper-page-content-wrapper-module__pageContainer--wdgZa {
  background-color: #071c35;
  padding: 0 10px;
}
`, "",{"version":3,"sources":["webpack://./src/js/pages/components/pageContentWrapper/page-content-wrapper.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,eAAe;AACjB","sourcesContent":[".pageContainer {\n  background-color: #071c35;\n  padding: 0 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": `src-js-pages-components-pageContentWrapper-page-content-wrapper-module__pageContainer--wdgZa`
};
export default ___CSS_LOADER_EXPORT___;
